export default __webpack_public_path__ + "static/media/J744_CoC.038999ee.pdf";